import { render, staticRenderFns } from "./SocialMediaLinks.vue?vue&type=template&id=26a528ac&scoped=true&"
import script from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
export * from "./SocialMediaLinks.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaLinks.vue?vue&type=style&index=0&id=26a528ac&lang=scss&scoped=true&"
import style1 from "./SocialMediaLinks.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a528ac",
  null
  
)

export default component.exports